import React from "react";
import avatar from "../Assets/imgs/avatar.png";

interface Props {
  message: any;
  currentUid: string;
  employeeList: any;
}

const Chat: React.FC<Props> = ({ message, currentUid ,employeeList}) => {
  const isSentByMe = message.uid === currentUid;

    // Find the employee who sent the message
 const senderName = isSentByMe
    ? "You"
    : employeeList[String(message.uid)] || "Unknown";

  return (
    <div style={{ textAlign: isSentByMe ? "right" : "left", margin: "12px 0" }}>
      <div className={`message__inner ${isSentByMe ? "sent" : ""}`}>
        <div className="messanger__name">{senderName}</div>
        <div className="flex-gap">
          <div className="chat__avatar">
            <img src={avatar} alt="avatar" />
          </div>
          <div className="message">{message.text}</div>
        </div>
      </div>
    </div>
  );
};

export default Chat;
